import VerticalColumnChart from './VerticalColumnChart';

export default VerticalColumnChart;

export type { IVerticalColumn, IVerticalColumnChartProps } from './VerticalColumnChart';
